export default __webpack_public_path__ + "static/media/error.f4c49f9a.svg";